<template>
  <div class="register">
    <header>
      <nav class="site-navbar">
        <div class="site-navbar__header" style="width: 500px;">
          <h1 class="site-navbar__brand" @click="$router.push({ name: 'register' })">
            <a class="site-navbar__brand-lg" href="javascript:;"><img src="~@/assets/img/logo.png" style="height: 32px;"
                                                                      alt=""><span style="padding-left: 10px">黄石市公共资源交易服务中心</span></a>
            <a class="site-navbar__brand-mini" href="javascript:;"><img src="~@/assets/img/logo.png"
                                                                        style="height: 34px;" alt=""></a>
          </h1>
        </div>
      </nav>
    </header>
    <main v-if="detShow">
      <div class="bgImg">
        <img src="~@/assets/img/step2.png" alt="">
      </div>
      <div class="menu">
        <el-form :model="userInfo" :rules="rules" ref="userInfo" label-width="150px" class="demo-ruleForm">
<!--          <el-form-item label="登录名" prop="loginName">-->
<!--            <el-input v-model="userInfo.loginName" placeholder="建议使用企业中文名称"></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item label="密码" prop="passWord">-->
<!--            <el-input type="password" v-model="userInfo.passWord" placeholder="8到16个字符包含大写字母、小写字母、数字，不包含特殊字符"></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item label="确认密码" prop="confirmPassword">-->
<!--            <el-input type="password" v-model="userInfo.confirmPassword"></el-input>-->
<!--          </el-form-item>-->
          <el-form-item label="注册主体类型" prop="mainType">
            <el-radio-group v-model="userInfo.mainType" @change="changeIndexBtn($event)">
              <el-radio label="1">企业</el-radio>
              <el-radio label="2">自然人</el-radio>
            </el-radio-group>
            <template v-if="userInfo.mainType==1">
              <div>企业注册用户，需插入公司锁进行注册</div>
            </template>
            <template v-else>
              <div>自然人注册用户，需插入自然人锁进行注册</div>
            </template>
          </el-form-item>
          <el-form-item v-if="changeIndex == 1" label="统一社会信用代码" prop="mainCode">
            <el-input style="width: 300px;margin-right: 15px;display: inline-block" v-model="userInfo.mainCode" disabled></el-input><!---->
            <el-button style="width: 130px;display: inline-block" type="primary" @click="CALogin">获取CA信息</el-button>
          </el-form-item>
          <el-form-item v-if="changeIndex == 1" label="单位名称" prop="entName">
            <el-input v-model="userInfo.entName":readonly="true"></el-input><!--:readonly="true"-->
          </el-form-item>
          <el-form-item v-if="changeIndex == 2" label="身份证信息" prop="idCard">
            <el-input style="width: 300px;margin-right: 15px;display: inline-block" v-model="userInfo.idCard" disabled></el-input>
            <el-button style="width: 130px;display: inline-block" type="primary" @click="CALogin">获取身份证信息</el-button>
          </el-form-item>
          <el-form-item v-if="changeIndex == 2" label="姓名" prop="userName">
            <el-input v-model="userInfo.userName"></el-input>
          </el-form-item>
          <el-form-item label="申报人" prop="declarant">
            <el-input v-model="userInfo.declarant"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="linkPhone">
            <el-input v-model="userInfo.linkPhone"></el-input>
          </el-form-item>
          <el-form-item label="短信验证码" prop="smsVerificationCode">
            <el-input style="width: 300px;margin-right: 15px;display: inline-block"
                      v-model="userInfo.smsVerificationCode"></el-input>
            <el-button v-if="phoneShow" style="width: 130px;display: inline-block" type="primary" @click="getShouji">
              获取验证码
            </el-button>
            <el-button disabled v-else style="width: 130px;display: inline-block">{{count}}s</el-button>
          </el-form-item>
          <el-form-item v-if="userInfo.mainType === '1'" label="用户类型" prop="userTypes1">
            <div class="title">
              <span style="flex-basis: 80%;border-right: none;border-bottom: none;">公共资源服务</span>
              <span style="flex-basis: 20%;border-bottom: none;">政务服务</span>
            </div>
            <div class="title">
              <span>工程建设</span>
              <span>政府采购</span>
              <span>国有产权</span>
              <span>国土交易</span>
              <span>中介超市</span>
            </div>
            <el-checkbox-group v-model="userTypes1"  @change="checkboxbtn1">
              <div>
                <el-checkbox v-for="(item,index) in userTypeList.jsgc" :key="item.id" :label="item.id" name="type">
                  {{item.name}}
                </el-checkbox>
              </div>
              <div>
                <el-checkbox v-for="(item,index) in userTypeList.zfcg" :key="item.id" :label="item.id" name="type">
                  {{item.name}}
                </el-checkbox>
              </div>
              <div>
                <el-checkbox v-for="(item,index) in userTypeList.gycq" :key="item.id" :label="item.id" name="type">
                  {{item.name}}
                </el-checkbox>
              </div>
              <div>
                <el-checkbox v-for="(item,index) in userTypeList.gtjy" :key="item.id" :label="item.id" name="type">
                  {{item.name}}
                </el-checkbox>
              </div>
              <div>
                <el-checkbox v-for="(item,index) in userTypeList.zjcs" :key="item.id" :label="item.id" name="type">
                  {{item.name}}
                </el-checkbox>
              </div>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item v-else class="ziRan" label="用户类型" prop="userTypes1">
            <div class="title">
              <span>国有产权</span>
              <span>国土交易</span>
            </div>
            <el-checkbox-group v-model="userTypes2" @change="checkboxbtn2">
              <div>
                <el-checkbox v-if="item.name === '国有-竞买人'" v-for="item in userTypeList.gycq" :key="item.id" :label="item.id" name="type">{{item.name}}
                </el-checkbox>
              </div>
              <div>
                <el-checkbox v-for="item in userTypeList.gtjy" :key="item.id" :label="item.id" name="type">
                  {{item.name}}
                </el-checkbox>
              </div>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="验证码" prop="verificationCode">
            <el-input style="width: 300px;margin-right: 10px;display: inline-block"
                      v-model="userInfo.verificationCode"></el-input>
            <div style="width: 130px;display: inline-block" class="reg-captcha">
              <img :src="captchaPath" @click="getCaptcha()" alt="">
            </div>
          </el-form-item>
            <el-form-item label="基本账户账号 : " size="small">
                <el-select v-model="value" placeholder="请选择">
                    <el-option
                            v-for="item in cities"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        <span style="float: left">{{ item.label }}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
                    </el-option>
                </el-select>
            </el-form-item>
          <el-form-item style="text-align: center">
            <el-button @click="goBack">返回</el-button>
            <el-button type="primary" @click="subUser">注册</el-button>
          </el-form-item>
        </el-form>
      </div>
    </main>
    <main v-else>
      <div class="bgImg">
        <img src="~@/assets/img/step3.png" alt="">
      </div>
      <div  class="complete">
        <h2>
          恭喜您，注册成功
        </h2>
        <h3>（请记录您的信息）</h3>
        <el-form :model="userInfo" ref="userInfo" label-width="150px" class="demo-ruleForm">
<!--          <el-form-item label="登录名" prop="loginName">-->
<!--            <p>{{userInfo.loginName}}</p>-->
<!--          </el-form-item>-->
          <el-form-item label="注册主体类型" prop="mainType">
            <p v-if="userInfo.mainType === '1'">企业</p>
            <p v-else>自然人</p>
          </el-form-item>
          <el-form-item v-if="userInfo.mainType === '1'" label="单位名称" prop="entName">
            <p>{{userInfo.entName}}</p>
          </el-form-item>
          <el-form-item v-else label="姓名" prop="userName">
            <p>{{userInfo.userName}}</p>
          </el-form-item>
          <el-form-item v-if="userInfo.mainType === '1'" label="统一社会信用代码" prop="mainCode">
            <p>{{userInfo.mainCode}}</p>
          </el-form-item>
          <el-form-item v-else label="身份证号" prop="idCard">
            <p>{{userInfo.idCard}}</p>
          </el-form-item>
          <el-form-item label="申报人" prop="declarant">
            <p>{{userInfo.declarant}}</p>
          </el-form-item>
          <el-form-item label="联系电话" prop="linkPhone">
            <p>{{userInfo.linkPhone}}</p>
          </el-form-item>
          <el-form-item label="用户类型" prop="linkPhone">
            <span style="margin-right: 10px;" v-for="(item,index) in typeList" :key="index">{{item.value}}</span>
          </el-form-item>
          <el-form-item style="text-align: center">
            <el-button @click="goLogin">登录完善信息</el-button>
          </el-form-item>
        </el-form>
      </div>
    </main>
  </div>
</template>

<script>
  import {initCa, getCaInfo, SignData} from '../../utils/CertTools'
  import {getUUID} from '@/utils'
  export default {
    name: "registerInfo",
    data() {
      var validateConfirmPassword = (rule, value, callback) => {
        if (this.userInfo.passWord !== value) {
          callback(new Error('确认密码与密码不一致'))
        } else {
          callback()
        }
      }
      var  CheckSocialCreditCode = (rule,Code,callback) => {
          var patrn = /^[0-9A-Z]+$/;
          //18位校验及大写校验
          if ((Code.length != 18) || (patrn.test(Code) == false)) {
              callback(new Error('请输入正确的统一社会信用代码，长度为18位'))
          }else {
            var reg = /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g;
            if(!reg.test(Code)){
                callback(new Error('请输入正确格式的统一社会信用代码，长度为18位'))
                return false;
            }
              // var Ancode;//统一社会信用代码的每一个值
              // var Ancodevalue;//统一社会信用代码每一个值的权重
              // var total = 0;
              // var weightedfactors = [1, 3, 9, 27, 19, 26, 16, 17, 20, 29, 25, 13, 8, 24, 10, 30, 28];//加权因子
              // var str = '0123456789ABCDEFGHJKLMNPQRTUWXY';
              // //不用I、O、S、V、Z
              // for (var i = 0; i < Code.length - 1; i++) {
              //     Ancode = Code.substring(i, i + 1);
              //     Ancodevalue = str.indexOf(Ancode);
              //     total = total + Ancodevalue * weightedfactors[i];
              //     //权重与加权因子相乘之和
              // }
              // var logiccheckcode = 31 - total % 31;
              // if (logiccheckcode == 31) {
              //     logiccheckcode = 0;
              // }
              // var Str = "0,1,2,3,4,5,6,7,8,9,A,B,C,D,E,F,G,H,J,K,L,M,N,P,Q,R,T,U,W,X,Y";
              // var Array_Str = Str.split(',');
              // logiccheckcode = Array_Str[logiccheckcode];
              // var checkcode = Code.substring(17, 18);
              // if (logiccheckcode != checkcode) {
              //   callback(new Error('请输入正确格式的统一社会信用代码，长度为18位'))
              //   return false;
              // }
          }
      }
      return {
          cities: [{
              value: 'Beijing',
              label: '北京'
          }, {
              value: 'Shanghai',
              label: '上海'
          }, {
              value: 'Nanjing',
              label: '南京'
          }, {
              value: 'Chengdu',
              label: '成都'
          }, {
              value: 'Shenzhen',
              label: '深圳'
          }, {
              value: 'Guangzhou',
              label: '广州'
          }],
          value: '',
        changeIndex:1,
        detShow:true,
        captchaPath: '',
        userTypeList: '',
        typeList:'',
        uuid:'',
        //倒计时
        phoneShow: true,
        count: '',
        timer: null,
        userTypes1: [],
        userTypes2: [],
        userInfo: {
          loginName: '',
          passWord: '',
          confirmPassword: '',
          mainType: '1',
          entName: '',
          userName: '',
          mainCode: '',
          idCard: '',
          declarant: '',
          linkPhone: '',
          smsVerificationCode: '',
          verificationCode:'',
          //CA
          sysCaInfoVo: {
            caCode: '',
            caLegalCode: '',//社会信用代码
            friendlyName: '',
            fromDate: '',//有效期开始时间
            expireDate: '',//有效期结束时间
            caName: '',
            caIdCard:'',
          },
        },
        userTypesArr:'',
        dataType:'',
        isDown:false,
        rules: {
          loginName: [
            { required: true, message: '请输入用户名', trigger: 'change' },
            { min: 5, max: 20, message: '长度在 5 到 20 个字符', trigger: 'change' }
          ],
          passWord: [
            { required: true, message: '请输入密码', trigger: 'change' },
            { min: 8, max: 16, message: '长度在 8 到 16 个字符', trigger: 'change' },
            {
              required: true,
              pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,16}$/g,
              // message: '请输入正确的密码格式',
              message: '至少1个大写字母，1个小写字母和1个数字,不能包含特殊字符（非数字字母）',
              trigger: 'blur'
            }
          ],
          confirmPassword: [
            { required: true, message: '请再次输入密码', trigger: 'blur' },
            { min: 8, max: 16, message: '长度在 8 到 16 个字符', trigger: 'blur' },
            { validator: validateConfirmPassword, trigger: 'blur' }
          ],
          entName: [
            { required: true, message: '请输入单位名称', trigger: 'blur' },
             {max: 50, message: '最多输入50个字符', trigger: 'blur' }
          ],
          mainCode: [
            { required: true, message: '请输入统一社会信用代码', trigger: 'blur' },
            // {
            //   required: true,
            //   pattern: /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g,
            //   message: '请输入正确的统一社会信用代码，由十八位数字或大写英文字母(不适用I、O、Z、S、V)',
            //   trigger: 'blur'
            // },
            { validator: CheckSocialCreditCode, trigger: 'blur' },
          ],
          userName: [
            { required: true, message: '请输入姓名', trigger: 'blur' }
          ],
          idCard: [
            { required: true, message: '请输入身份证号', trigger: 'blur' },
            { min: 15, max: 18, message: '请如实填写正确号码，长度在15~18位', trigger: 'blur' },
            {
              required: true,
              pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
              message: '请输入正确的身份证号码',
              trigger: 'blur'
            }
          ],
          userTypes: [
            { type: 'array', required: true, message: '请至少选择一个用户类型', trigger: 'change' }
          ],
          declarant: [
            { required: true, message: '请输入申报人', trigger: 'blur' }
          ],
          linkPhone: [
            { required: true, message: '请输入手机号', trigger: 'blur' },
            { required: true, pattern: /^((13|14|15|16|17|18)[0-9]{1}\d{8})|((166|199|198)[0-9]{1}\d{7})$/, message: '请输入正确的手机', trigger: 'blur' }
          ],
          smsVerificationCode: [
            { required: true, message: '请输入手机验证码', trigger: 'blur' }
          ],
          verificationCode: [
            { required: true, message: '请输入图形验证码', trigger: 'blur' }
          ],
        },
      };
    },
    methods: {
      //初始化CA
      CALogin() {
        initCa((isIE) => {
          if (!isIE) {
            this.$alert(
              "请使用ie10及以上浏览器",
              "提示",
              {confirmButtonText: "确定"}
            );
          }
        })
        getCaInfo((certInfo) => {
            if(this.changeIndex == 1){
              this.userInfo.mainCode = certInfo.caLegalCode;
              this.userInfo.entName = certInfo.certName;
            }else{
              this.userInfo.idCard = certInfo.caIdCard;
              this.userInfo.userName = certInfo.certName;
            }
            this.userInfo.sysCaInfoVo.caCode = certInfo.certserial,
            this.userInfo.sysCaInfoVo.legalCode = certInfo.caLegalCode,
            this.userInfo.sysCaInfoVo.friendlyName = certInfo.friendlyName,
            this.userInfo.sysCaInfoVo.fromDate = this.formFilter(certInfo.validstarttime),
            this.userInfo.sysCaInfoVo.expireDate = this.formFilter(certInfo.validendtime),
            this.userInfo.sysCaInfoVo.caName = certInfo.certName,
            this.userInfo.sysCaInfoVo.caIdCard = certInfo.caIdCard
        })
      },
      changeIndexBtn(index){
        this.changeIndex = index;
        // this.$refs["userInfo" ].resetFields();
      },
      checkboxbtn1(){
        this.userTypesArr = this.userTypes1
      },
      checkboxbtn2(){
        this.userTypesArr = this.userTypes2
      },
      // 获取验证码
      getCaptcha() {
        this.uuid = getUUID()
        this.$http.get(`/ent/captchaCode.png?uuid=${this.uuid}`, {
            responseType: 'arraybuffer'
          }).then(response => {
            return 'data:image/png;base64,' + btoa(
              new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
            )
          }).then(data => {
            this.captchaPath  = data
          })
      },
      getShouji() {
        this.$http.post('/register/getSms', {
          linkPhone: this.userInfo.linkPhone
        }).then(res => {
          if (res.data.code !== '1') {
            this.$alert(res.data.msg, '警告', {
              confirmButtonText: '确定',
            })
            this.userInfo.userTypes = this.userTypesArr.split(",")
            return;
          }
          this.$notify({
            title: '发送验证码',
            message: res.data.msg,
            position: 'bottom-right'
          })
          const TIME_COUNT = 60;
          if (!this.timer) {
            this.count = TIME_COUNT;
            this.phoneShow = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.phoneShow = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000)
          }
        })
      },
      getUserType() {
        this.$http.post('/register/getRoleType').then(res => {
          this.userTypeList = JSON.parse(res.data.data)
        })
      },
      ceshi(Code){
        var reg = /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g;
        if(reg.test(Code)){
          this.isDown = true
        }
      },
      subUser() {
        if(this.changeIndex == 1){
            this.ceshi(this.userInfo.mainCode)
        }else{
          this.isDown = true
        }
        if(this.isDown == true){
            this.dataType = this.userInfo
            this.$http.post('/base/getbyroleids?roleIds=' + this.userTypesArr.join(",")).then(res => {
              this.typeList = res.data.data;
              this.getCaptcha()
            })
            if (this.userInfo.passWord !== this.userInfo.confirmPassword){
              this.$alert('两次输入密码不一致，请重新输入', '警告', {
                confirmButtonText:'确定',
              })
              return;
            }
            if(this.userTypesArr){
                this.dataType.userTypes = this.userTypesArr.join(',')
            }
            this.$http.post('/register/save', this.dataType).then(res => {
              if (res.data.code !== '1') {
                this.$alert(res.data.msg, '警告', {
                  confirmButtonText:'确定',
                })
                this.dataType.userTypes = this.userTypesArr.split(",")
                return;
              }
              this.$notify({
                title: '注册',
                message: res.data.msg,
                position: 'bottom-right'
              })
              this.detShow = false;
            })
        }
      },
      goBack(){
        this.$router.back(-1)
      },
      goLogin(){
        this.$router.push({
          path:'/home'
        })
      },
      formFilter(data){
        var qyear=new Date().getFullYear();
        var q2year=qyear.toString().slice(0,2);
        var time=q2year+data;
        var year=time.substring(0,4);
        var month=time.substring(4,6);
        var date=time.substring(6,8);
        var hour=time.substring(8,10);
        var minute=time.substring(10,12);
        var second=time.substring(12,14);
        return year+"-"+month+"-"+date+" "+hour+":"+minute+":"+second;
      },
    },
    created() {
      this.getCaptcha();
      this.getUserType()
    },
  }
</script>

<style scoped>



</style>
